// Polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

// 3rd
import Vue from 'vue';
import VueWait from 'vue-wait';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify, { i18n } from './plugins/vuetify';
import VueTour from 'vue-tour'
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';


import env from './utils/env';

import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";

import VueMeta from 'vue-meta';

import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition';

import dateFilter from './filters/date.js';
import numberFilter from './filters/number.js';
import balanceFilter from './filters/balance.js';
import masterFormatFilter from './filters/masterFormat.js';
import slugifyFilter from './filters/slugify.js';

import './scss/app.scss';
import {
    disableFirebase, evaluatePlatform, getMobileOperatingSystem,
    isFirebaseSettingAvailable,
} from './utils/helper';

Vue.config.productionTip = false;

// use plugins
Vue.use(VueWait);
Vue.use(VueMeta);
Vue.use(VueTour);

// filters
Vue.filter('date', dateFilter);
Vue.filter('number', numberFilter);
Vue.filter('balance', balanceFilter);
Vue.filter('master', masterFormatFilter);
Vue.filter('slugify', slugifyFilter);

// transitions
const slideLeftTransition = createSimpleTransition('slide-left');
const slideRightTransition = createSimpleTransition('slide-right');
Vue.component('v-slide-left-transition', slideLeftTransition);
Vue.component('v-slide-right-transition', slideRightTransition);

if (isFirebaseSettingAvailable() && evaluatePlatform() !== 'app') {
    const firebaseConfig = {
        apiKey: env('firebase-api-key'),
        authDomain: env('firebase-auth-domain'),
        databaseURL: env('firebase-database-url'),
        projectId: env('firebase-project-id'),
        storageBucket: env('firebase-storage-bucket'),
        messagingSenderId: env('firebase-messaging-sender-id'),
        appId: env('firebase-app-id'),
        measurementId: env('firebase-measurement-id'),
    };

    firebase.initializeApp(firebaseConfig);
    // firebase.analytics();

    // alias
    // Vue.prototype.$analytics = firebase.analytics();

    // disable it first
    disableFirebase();
}

if (process.env.NODE_ENV !== 'development') {
    Sentry.init({
        dsn: env('sentry'),
        integrations: [new VueIntegration({Vue, attachProps: true})],
    });
}

window.handleOpenURL = (url) => {
    setTimeout(function () {
        const path = url.replace('mastersclub://', '');
        localStorage.setItem('redirectTo', path);
        router.push(`/${path}`);
    }, 0);
};

// set the start locale to use
export default new Vue({
    i18n,
    router,
    store,
    vuetify,
    wait: new VueWait({
        useVuex: true,
    }),
    render: h => h(App)
}).$mount('#app');
